<template>
  <div class="admin-page">
<div class="management-cards">
      <el-card class="management-card" @click="navigateTo('/admin/users')" shadow="hover">
        <div class="card-content">
          <div class="card-icon">
            <el-icon size="48"><User /></el-icon>
          </div>
          <div class="card-info">
            <h3>用户管理</h3>
            <p>管理系统用户，包括查看、编辑、删除用户信息</p>
          </div>
        </div>
      </el-card>
      
      <el-card class="management-card" @click="navigateTo('/admin/user-audit')" shadow="hover">
        <div class="card-content">
          <div class="card-icon">
            <el-icon size="48"><Check /></el-icon>
          </div>
          <div class="card-info">
            <h3>用户资料审核</h3>
            <p>审核用户资料变更，对比原值和新值，确保信息准确性</p>
          </div>
        </div>
      </el-card>
      
      <el-card class="management-card" @click="navigateTo('/admin/referral-coupons')" shadow="hover">
        <div class="card-content">
          <div class="card-icon">
            <el-icon size="48"><Ticket /></el-icon>
          </div>
          <div class="card-info">
            <h3>推荐券管理</h3>
            <p>管理用户礼券、专享券发放与禁用</p>
          </div>
        </div>
      </el-card>

      <el-card class="management-card" @click="navigateTo('/admin/referral-bindings')" shadow="hover">
        <div class="card-content">
          <div class="card-icon">
            <el-icon size="48"><Share /></el-icon>
          </div>
          <div class="card-info">
            <h3>推荐绑定 / 分润</h3>
            <p>绑定记录、分润流水、撤销与礼遇重试</p>
          </div>
        </div>
      </el-card>

      <el-card class="management-card" @click="navigateTo('/admin/idcard-audit')" shadow="hover">
        <div class="card-content">
          <div class="card-icon">
            <el-icon size="48"><CreditCard /></el-icon>
          </div>
          <div class="card-info">
            <h3>身份证审核</h3>
            <p>审核用户身份证认证申请，验证身份证信息的真实性</p>
          </div>
        </div>
      </el-card>

      <el-card class="management-card" @click="navigateTo('/admin/home-carousel')" shadow="hover">
        <div class="card-content">
          <div class="card-icon">
            <el-icon size="48"><PictureFilled /></el-icon>
          </div>
          <div class="card-info">
            <h3>主页轮播图</h3>
            <p>管理首页轮播图的主标题、副标题、图片与展示状态</p>
          </div>
        </div>
      </el-card>

      <el-card class="management-card" @click="navigateTo('/admin/home-news')" shadow="hover">
        <div class="card-content">
          <div class="card-icon">
            <el-icon size="48"><Bell /></el-icon>
          </div>
          <div class="card-info">
            <h3>最新动态</h3>
            <p>管理首页「最新动态」区块的标题、摘要、正文与封面</p>
          </div>
        </div>
      </el-card>
      
      <el-card class="management-card" @click="navigateTo('/admin/blogs')" shadow="hover">
        <div class="card-content">
          <div class="card-icon">
            <el-icon size="48"><Document /></el-icon>
          </div>
          <div class="card-info">
            <h3>编辑推荐管理</h3>
            <p>管理编辑推荐文章，包括审核、编辑、删除内容</p>
          </div>
        </div>
      </el-card>
      
      <el-card class="management-card" @click="navigateTo('/admin/images')" shadow="hover">
        <div class="card-content">
          <div class="card-icon">
            <el-icon size="48"><Picture /></el-icon>
          </div>
          <div class="card-info">
            <h3>图片管理</h3>
            <p>管理系统图片资源，包括上传、预览、删除图片</p>
          </div>
        </div>
      </el-card>

      <el-card class="management-card" @click="navigateTo('/admin/knowledge/courses')" shadow="hover">
        <div class="card-content">
          <div class="card-icon"><el-icon size="48"><Reading /></el-icon></div>
          <div class="card-info">
            <h3>课程管理</h3>
            <p>管理知识课程、Banner 与知识点树结构</p>
          </div>
        </div>
      </el-card>

      <el-card class="management-card" @click="navigateTo('/admin/knowledge/points')" shadow="hover">
        <div class="card-content">
          <div class="card-icon"><el-icon size="48"><Collection /></el-icon></div>
          <div class="card-info">
            <h3>知识点管理</h3>
            <p>维护知识点、分类及前后置关系</p>
          </div>
        </div>
      </el-card>

      <el-card class="management-card" @click="navigateTo('/admin/knowledge/resources')" shadow="hover">
        <div class="card-content">
          <div class="card-icon"><el-icon size="48"><FolderOpened /></el-icon></div>
          <div class="card-info">
            <h3>资源管理</h3>
            <p>管理知识点学习资源并绑定知识点</p>
          </div>
        </div>
      </el-card>

      <el-card class="management-card" @click="navigateTo('/admin/exames')" shadow="hover">
        <div class="card-content">
          <div class="card-icon">
            <el-icon size="48"><Notebook /></el-icon>
          </div>
          <div class="card-info">
            <h3>测评管理</h3>
            <p>管理心理测评，包括新增、编辑、删除和查看测评</p>
          </div>
        </div>
      </el-card>

      <el-card class="management-card" @click="navigateTo('/admin/content-tags')" shadow="hover">
        <div class="card-content">
          <div class="card-icon">
            <el-icon size="48"><CollectionTag /></el-icon>
          </div>
          <div class="card-info">
            <h3>内容标签</h3>
            <p>维护测评 / 编辑推荐 / 课程字典标签，供列表筛选与编辑绑定</p>
          </div>
        </div>
      </el-card>

      <el-card class="management-card" @click="navigateTo('/admin/exam-badges')" shadow="hover">
        <div class="card-content">
          <div class="card-icon">
            <el-icon size="48"><Medal /></el-icon>
          </div>
          <div class="card-info">
            <h3>测评徽章配置</h3>
            <p>配置各测评金/银/铜徽章发放模式、分数线与是否启用</p>
          </div>
        </div>
      </el-card>

      <el-card class="management-card" @click="navigateTo('/admin/exam-results')" shadow="hover">
        <div class="card-content">
          <div class="card-icon">
            <el-icon size="48"><DataLine /></el-icon>
          </div>
          <div class="card-info">
            <h3>测评完成记录</h3>
            <p>按当天、当周、当月或时间段筛选用户新完成的测评，并查看结果详情</p>
          </div>
        </div>
      </el-card>

      <el-card class="management-card" @click="navigateTo('/admin/dependencies')" shadow="hover">
        <div class="card-content">
          <div class="card-icon">
            <el-icon size="48"><Monitor /></el-icon>
          </div>
          <div class="card-info">
            <h3>依赖健康检查</h3>
            <p>检测数据库、Redis、邮件 SMTP、微信配置等后台依赖是否正常</p>
          </div>
        </div>
      </el-card>

      <el-card
        v-if="isSuperAdmin"
        class="management-card"
        @click="navigateTo('/admin/database-backup')"
        shadow="hover"
      >
        <div class="card-content">
          <div class="card-icon">
            <el-icon size="48"><Download /></el-icon>
          </div>
          <div class="card-info">
            <h3>数据库备份</h3>
            <p>下载 MySQL 全库备份（ZIP），仅超级管理员</p>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { goToLogin } from '@/utils/loginFlow'
import { ref } from 'vue'
import { User, Document, Picture, PictureFilled, Bell, Check, CreditCard, Download, Notebook, Reading, Collection, FolderOpened, Ticket, Share, DataLine, Medal, Monitor, CollectionTag } from '@element-plus/icons-vue'
import { useRouter } from 'vue-router'
import { isSuperAdmin as checkSuperAdmin } from '@/utils/sysRole'

export default {
  name: 'AdminDashboard',
  components: {
    User,
    Document,
    Picture,
    PictureFilled,
    Bell,
    Check,
    CreditCard,
    Download,
    Notebook,
    DataLine,
    Reading,
    Collection,
    FolderOpened,
    Ticket,
    Share,
    Medal,
    Monitor,
    CollectionTag
  },
  setup() {
    const router = useRouter()
    const isSuperAdmin = ref(false)
    
    // 检查是否登录
    const checkLogin = () => {
      if (!localStorage.getItem('jwt_token')) {
        goToLogin(router)
        return false
      }
      return true
    }
    
    // 在组件创建时检查登录状态
    if (!checkLogin()) {
      return {}
    }
    
    const navigateTo = (path) => {
      router.push(path)
    }

    try {
      const user = JSON.parse(localStorage.getItem('user_info') || '{}')
      isSuperAdmin.value = checkSuperAdmin(user.sysRole)
    } catch {
      isSuperAdmin.value = false
    }

    return {
      navigateTo,
      isSuperAdmin
    }
  }
}
</script>

<style scoped>

.admin-dashboard {
  padding: 0;
}

.management-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 20px;
}

.management-card {
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  border-radius: 8px;
}

.management-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.card-content {
  display: flex;
  align-items: center;
  padding: 20px;
}

.card-icon {
  margin-right: 20px;
  color: #409eff;
}

.card-info h3 {
  margin: 0 0 10px 0;
  font-size: 20px;
  color: #303133;
}

.card-info p {
  margin: 0;
  font-size: 14px;
  color: #606266;
  line-height: 1.5;
}

@media (max-width: 768px) {
  .management-cards {
    grid-template-columns: 1fr;
  }
  
  .card-content {
    flex-direction: column;
    text-align: center;
  }
  
  .card-icon {
    margin-right: 0;
    margin-bottom: 15px;
  }
}

</style> 